if (!customElements.get('whatsapp-chat')) {
  customElements.define('whatsapp-chat', class extends HTMLElement {
    connectedCallback() {
      this.statusLabel = this.querySelector('.whatsapp-chat__status');
      this.link = this.querySelector('.whatsapp-button');
      if (!this.statusLabel || !this.link) return;

      this.updateAvailability = () => {
        const delayed = this.dataset.mode === 'delayed' ||
          (this.dataset.mode === 'automatic' && !this.isAvailable(new Date()));
        this.statusLabel.hidden = !delayed;
        this.link.setAttribute('aria-describedby', delayed
          ? 'a11y-new-window-message whatsapp-availability'
          : 'a11y-new-window-message');
      };

      this.updateAvailability();
      if (this.dataset.mode === 'automatic') {
        this.timer = window.setInterval(this.updateAvailability, 15000);
        document.addEventListener('visibilitychange', this.updateAvailability);
        window.addEventListener('pageshow', this.updateAvailability);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.updateAvailability);
      window.removeEventListener('pageshow', this.updateAvailability);
    }

    isAvailable(date) {
      try {
        this.formatter ??= new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.timezone,
          weekday: 'short',
          hour: '2-digit',
          hourCycle: 'h23',
        });
        const parts = Object.fromEntries(this.formatter.formatToParts(date).map(part => [part.type, part.value]));
        const hour = Number(parts.hour);
        const open = Number(this.dataset.openHour);
        const close = Number(this.dataset.closeHour);
        const days = this.dataset.days.split(',');
        if (![open, close].every(value => Number.isInteger(value) && value >= 0 && value <= 23)) return false;
        const today = days.includes(parts.weekday);
        if (open === close) return today;
        if (open < close) return today && hour >= open && hour < close;

        const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const previousDay = weekdays[(weekdays.indexOf(parts.weekday) + 6) % 7];
        return (today && hour >= open) || (days.includes(previousDay) && hour < close);
      } catch {
        return false;
      }
    }
  });
}
